import { render, staticRenderFns } from "./RepairList.vue?vue&type=template&id=1c3ef486&scoped=true&"
import script from "./RepairList.vue?vue&type=script&lang=js&"
export * from "./RepairList.vue?vue&type=script&lang=js&"
import style0 from "./RepairList.vue?vue&type=style&index=0&id=1c3ef486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ef486",
  null
  
)

export default component.exports